<template>
    <div role="tabcard" class="tab-pane " :class="role == 'customer' || role == 'employee' ? 'active' : ''" id="overview">
        <project v-if="project" :role="role" :project="project" :overview="true" :expand="true"></project>
        <running-total v-if="showRunningTotal" :role="role" :project="project"></running-total>
    </div>
</template>
<script>
export default {
    props: ['role', 'project'],

    created: function() {

    },

    mounted: function() {

    },

    data: function() {
        return {};
    },

    watch: {},

    computed: {
        showRunningTotal: function() {
            return this.project && (this.isAdmin() || this.isCustomer());
        },
    },

    methods: {
        isCustomer: function() {
            return this.role === 'customer';
        },

        isEmployee: function() {
            return this.role === 'employee';
        },

        isAdmin: function() {
            return this.role === 'administrator' || this.role === 'owner';
        },
    }
}

</script>
